import React from "react";
import { Box, Typography } from "@mui/material";
import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";
import { FormattedMessage } from "react-intl";
import { pageBackgroundSx } from "./interviewTheme";
import { ContentSheet, HeaderOrb, PrimaryPill, SERIF } from "./RespondentFormKit";

// The greeting at the very start of a Modern (voice) survey: the orb, a hello,
// and a line asking for honest feedback, with every answer reviewed at the end.
export function VoiceWelcome({ t }) {
    return (
        <Box data-testid="voice-welcome" sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", mb: 2.75 }}>
            <HeaderOrb t={t} size={56} />
            <Typography sx={{ mt: 1.75, fontFamily: SERIF, fontWeight: 600, fontSize: { xs: "1.15rem", sm: "1.3rem" }, color: t.heading }}>
                <FormattedMessage id="voice_survey.welcome_title" defaultMessage="Hi there, thanks for joining us" />
            </Typography>
            <Typography sx={{ mt: 0.75, maxWidth: 520, color: t.panelMuted, lineHeight: 1.6 }}>
                {/* <FormattedMessage id="voice_survey.welcome_text" defaultMessage="We'd love your honest feedback." />{" "} */}
                <FormattedMessage id="voice_survey.welcome_review" defaultMessage="You'll be able to review your answers before you submit." />
            </Typography>
        </Box>
    );
}

// The greeting on a screen of its own: when the survey opens on an open-text
// question (which needs the whole screen) or has nothing in it yet. Next only
// when there is something to go on to.
export default function VoiceIntroScreen({ t, onNext, nextLabel }) {
    return (
        <Box data-testid="voice-intro" sx={{ minHeight: t.screenMinHeight || "100vh", flexGrow: 1, ...pageBackgroundSx(t), display: "flex", flexDirection: "column" }}>
            <ContentSheet t={t} maxWidth={760}>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", px: { xs: 2, sm: 3.75 }, pt: { xs: 3, sm: 4 }, pb: 3 }}>
                    <VoiceWelcome t={t} />
                    {onNext && (
                        <PrimaryPill t={t} onClick={onNext} endIcon={<ArrowForwardIcon />}>
                            {nextLabel || <FormattedMessage id="voice_survey.continue" defaultMessage="Continue" />}
                        </PrimaryPill>
                    )}
                </Box>
            </ContentSheet>
        </Box>
    );
}
